import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlash = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_424_17409)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.0682 13.8779L12.5719 18.5241L17.79 11.8779H12.6179L13.1135 7.24398L7.90584 13.8779H13.0682ZM15.4727 3.99219C15.5795 2.9934 14.312 2.47825 13.6917 3.26836L5.06293 14.2604C4.54781 14.9166 5.01529 15.8779 5.84952 15.8779H10.8432L10.2132 21.775C10.1065 22.7737 11.3738 23.2887 11.9941 22.4987L20.633 11.4954C21.1482 10.8392 20.6808 9.87785 19.8465 9.87785H14.8432L15.4727 3.99219Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_424_17409",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.847656 0.982422)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgFlash);
export default ForwardRef;
